export { default } from './Agree';
